<template>
  <div class="input-group">
    <b-form-input
      type="number"
      v-model="value"
      lazy :placeholder="$t('enter-number')"
      :min="getMin"
      :max="getMax"
      :step="interval"
      :state="isValid ? null : false"
      :disabled="!isConnectionOk"
    />
  </div>
</template>

<script>
import BaseControlMixin from '@/components/controls/mixins/BaseControl';
import NumberControl from '@/components/controls/mixins/NumberControl';

export default {
  name: 'NumberInput',
  mixins: [
    BaseControlMixin,
    NumberControl,
  ],
  data() {
    return {
      varsValue: this.vars[0].value,
    };
  },
  computed: {
    value: {
      get() {
        return this.getSingleVar.value;
      },
      set(value) {
        this.varsValue = value;
        if (this.isValid) {
          this.handleControl(this.varsValue);
        }
      },
    },
    isValid() {
      return this.varsValue >= this.getMin && this.varsValue <= this.getMax;
    },
  },
};
</script>

<style scoped>

</style>
